<template>
  <div class="checkAgreement-warpper">
    <div class="contentBox" ref="contentBox">
    <nav-bar titleText="查看协议" titleWeight="bold" @goBack="goBack" :isFixed="true"></nav-bar>
    <div class="interval"></div>
      <div class="agreement" v-html="content"></div>
    </div>
    <div class="agreement_box" ref="agreementBtn">
        <van-button type="primary" class="agreement_btn" @click="handleSubmit">已阅读并同意</van-button>
      </div>  
  </div>
</template>
<script>
import navBar from "../components/navBar";
export default {
  name: "checkAgreement",
  data() {
    return {
      content: '',
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.checkAgreement()
  },
  components: {
    navBar,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    checkAgreement(){
      const MENBER = 'sqjjr'
      this.$api.get('/cms/index/agreement/detail', {number: MENBER})
      .then(data => {
        this.content = data.content
      })
    },
    handleSubmit(){
      this.$router.push('/agent/introduceMyself')
    }
  },
  mounted(){
    const contentHeight =  this.$refs.contentBox.offsetHeight;
    const bodyHeight = document.getElementsByTagName("body")[0].offsetHeight;

          
    this.$refs.agreementBtn.style.marginTop = contentHeight>bodyHeight ? 20+'px' : bodyHeight - contentHeight-50+'px';
  }
};
</script>
<style lang="less">
.checkAgreement-warpper {
  background-color: #ffffff;
  min-height: 100%;
  font-size: 16px;
  color: #333;
  .interval {
    background-color: #F5F6F7;
    height: 15px;
  }
  .contentBox {
    background: #fff;
    // height: calc(100% - 22px);
  
    .agreement {
      // width: 100%;
      // height: 500px;
      padding: 88px 16px 88px;
    }

  }
      .agreement_box {
        position: fixed;
        bottom: 0;
        width: 100%;
        background-color: #ffffff;
        text-align: center;
        padding-bottom: 20px;
        margin-top: calc(100vh - 170px);
        .agreement_btn {
          width: 90%;
          height: 40px;
          font-size: 16px;
          display: block;
          border-radius: 30px;
          line-height: 40px;
          font-weight: 600;
          background: #fc740c;
          border: none;
          color: #fff;
          margin: 0 auto;
          text-align: center;
        }
    }
}
</style>





